import React from "react";

function ProductC() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Product C</h1>
      <p style={{ color: "gray" }}>Coming soon.</p>
    </div>
  );
}

export default ProductC;
